export default __webpack_public_path__ + "static/media/macro-influencer-new.43337078.png";